import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AdminPanel from './AdminPanel';
import './style1.css';

interface AddProgramProps {
    username: string | null;
    onLogout?: () => void;
}

const navLinks = [
    { name: 'HOME', href: '/' },
    { name: 'PROGRAMS', href: '/programs' },
    { name: 'VIDEOS', href: '/videos' },
    { name: 'IMAGES', href: '/images' },
    { name: 'DEMOS', href: '/demos' },
    { name: 'CERTIFICATES', href: '/certificates' },
    { name: 'ABOUT', href: '/about' },
];

const AddProgram: React.FC<AddProgramProps> = ({ username, onLogout }) => {
    const [name, setName] = useState('');
    const [url, setUrl] = useState('/addprogram/'); // changed to relative path
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const navigate = useNavigate();

    // Only admin can access
    if (username !== 'admin') {
        return <div style={{ textAlign: 'center', marginTop: '2rem' }}>Access denied.</div>;
    }

    return (
        <div className="modern-layout" style={{ position: 'relative' }}>
            <header className="modern-header">
                <div className="header-container">
                    <nav className="modern-nav">
                        {navLinks.map(link =>
                            link.href.startsWith('/')
                                ? <Link
                                    key={link.name}
                                    to={link.href}
                                    className="modern-nav-link"
                                    style={{ textDecoration: 'none' }}
                                  >
                                    {link.name}
                                  </Link>
                                : <a
                                    key={link.name}
                                    href={link.href}
                                    className="modern-nav-link"
                                  >
                                    {link.name}
                                  </a>
                        )}
                        {onLogout && (
                            <button className="logout-btn" onClick={onLogout}>LOG OUT</button>
                        )}
                    </nav>
                </div>
            </header>
            {/* Absolutely positioned AdminPanel, does not affect main content */}
            <div
                style={{
                    position: 'absolute',
                    left: 0,
                    top: 120, // adjust if your header is taller/shorter
                    zIndex: 10
                }}
            >
                <AdminPanel />
            </div>
            <main className="modern-content">
                <div
                    style={{
                        maxWidth: 400,
                        margin: '2rem auto',
                        background: '#fff',
                        borderRadius: 12,
                        boxShadow: '0 2px 16px #6a11cb22',
                        padding: '2rem'
                    }}
                >
                    <h2 style={{ textAlign: 'center', marginBottom: '1.5rem' }}>Add Program</h2>
                    <form onSubmit={async (e) => {
                        e.preventDefault();
                        setError('');
                        setSuccess('');
                        if (!name || !url) {
                            setError('Both fields are required.');
                            return;
                        }
                        try {
                            const token = localStorage.getItem('token');
                            const response = await fetch('/addprogram', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${token}`
                                },
                                body: JSON.stringify({ name, url }),
                            });
                            if (response.ok) {
                                setSuccess('Program added!');
                                setName('');
                                setUrl('/addprogram/'); // reset to relative path
                            } else {
                                const data = await response.json();
                                setError(data.message || 'Failed to add program.');
                            }
                        } catch (err) {
                            setError('Network error.');
                        }
                    }}>
                        <div style={{ marginBottom: '1rem' }}>
                            <label>Name:</label>
                            <input
                                type="text"
                                value={name}
                                onChange={e => setName(e.target.value)}
                                style={{ width: '100%', padding: '0.5rem', marginTop: 4 }}
                            />
                        </div>
                        <div style={{ marginBottom: '1rem' }}>
                            <label>URL:</label>
                            <input
                                type="text"
                                value={url}
                                onChange={e => setUrl(e.target.value)}
                                style={{ width: '100%', padding: '0.5rem', marginTop: 4 }}
                            />
                        </div>
                        {error && <div style={{ color: 'red', marginBottom: '1rem' }}>{error}</div>}
                        {success && <div style={{ color: 'green', marginBottom: '1rem' }}>{success}</div>}
                        <button
                            type="submit"
                            style={{
                                width: '100%',
                                padding: '0.75rem',
                                background: 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)',
                                color: '#fff',
                                border: 'none',
                                borderRadius: 6,
                                fontWeight: 'bold',
                                cursor: 'pointer'
                            }}
                        >
                            Add
                        </button>
                    </form>
                </div>
            </main>
            <footer className="modern-footer">
                &copy; {new Date().getFullYear()} Timo
            </footer>
        </div>
    );
};

export default AddProgram;